
class StopWatch {
    constructor() {
        this.startTime = null;
        this.endTime = null;
    }

    start() {
        this.startTime = performance.now();
        this.endTime = null;
    }

    stop() {
        this.endTime = performance.now();
    }

    elapsed() {
        if (!this.startTime || !this.endTime) return "Not stopped yet";
        const elapsedMs = this.endTime - this.startTime;
        return (elapsedMs / 1000).toFixed(2) + "sec"; // Convert ms to seconds with 2 decimal places
    }
}

export default StopWatch;